'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _clinics = require('../actions/clinics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(loadClinics),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getBranchDetails),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(clinicsSaga);

/**
 * Loads clinics from getAccountStructure API
 */
function loadClinics(actions) {
  var accountToken, apiObj, clinicsRes;
  return _regenerator2.default.wrap(function loadClinics$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          apiObj = new _webUtils.API();
          _context.next = 5;
          return apiObj.get(_webUtils.Urls.getAccountStructure + '?languageId=' + (actions.language === 'en' ? 1 : 2), [{
            key: 'x-vzt-authentication',
            value: accountToken
          }]);

        case 5:
          clinicsRes = _context.sent;

          if (!_webUtils.STATUS.isSuccess(clinicsRes.status)) {
            _context.next = 11;
            break;
          }

          _context.next = 9;
          return (0, _effects.put)((0, _clinics.loadClinicsDone)(clinicsRes));

        case 9:
          _context.next = 13;
          break;

        case 11:
          _context.next = 13;
          return (0, _effects.put)((0, _clinics.loadClinicsFail)('Failed to load clinics'));

        case 13:
          _context.next = 19;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context['catch'](0);
          _context.next = 19;
          return (0, _effects.put)((0, _clinics.loadClinicsFail)('Failed to load clinics'));

        case 19:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 15]]);
}

function getBranchDetails(actions) {
  var accountToken, apiObj, response;
  return _regenerator2.default.wrap(function getBranchDetails$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          apiObj = new _webUtils.API();
          _context2.next = 4;
          return apiObj.get(_webUtils.Urls.getBranchDetails + '/' + actions.branchKey, [{
            key: 'x-vzt-authentication',
            value: accountToken
          }]);

        case 4:
          response = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context2.next = 10;
            break;
          }

          _context2.next = 8;
          return (0, _effects.put)((0, _clinics.getBranchDetailsSuccess)(response));

        case 8:
          _context2.next = 12;
          break;

        case 10:
          _context2.next = 12;
          return (0, _effects.put)((0, _clinics.getBranchDetailsFail)(response));

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function clinicsSaga() {
  return _regenerator2.default.wrap(function clinicsSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_clinics.CLINICS.LOAD, loadClinics);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeEvery)(_clinics.BRANCH_DETAILS.LOAD, getBranchDetails);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = clinicsSaga;
module.exports = exports['default'];